module.exports = __webpack_public_path__ + "images/assets/a795197c2c1cba13e913c74c1104efc8.svg";